export function formatPrice(price: number | string): string {
    const priceStr = price.toString();
    const formatted = priceStr.replace(/\B(?=(\d{3})+(?!\d))/g, '،');
    return `${formatted} تومان`;
}
